import React, { memo, useRef, useState, useCallback } from "react";
import { compose } from "@reduxjs/toolkit";

import withProfile from "contexts/with-profile";
import withCompanies from "contexts/with-companies";
import AppAlert from "components/app-alert";
import AppHeader from "components/app-header";
import AppSideNav from "components/app-side-nav";
import AppInactivityLogoutModal from "components/app-inactivity-logout-modal";
import useInactivityLogout from "hooks/use-inactivity-logout";

const AppLayout = ({ children, ...props }) => {
	const sideNavRef = useRef();
	const [title, setTitle] = useState("");
	const [backTitle, setBackTitle] = useState("");

	const { isInactive, onHandleConfirmLogout } = useInactivityLogout();

	const onHandleSetTitle = useCallback((text) => {
		setTitle(text);
	}, []);

	const onHandleSetBackTitle = useCallback((text) => {
		setBackTitle(text);
	}, []);

	const onHandleToggleSideNav = useCallback(() => {
		sideNavRef.current.onHandleToggleSideNav();
	}, []);

	return (
		<div className="app-layout">
			<AppAlert />
			<AppInactivityLogoutModal visible={isInactive} onHandleConfirm={onHandleConfirmLogout} />

			<main className="main">
				<AppSideNav ref={sideNavRef} onHandleSetTitle={onHandleSetTitle} onHandleSetBackTitle={onHandleSetBackTitle} onHandleSelectCompany={props.onHandleSelectCompany} />

				<div id="layout-container" className="main__container">
					<AppHeader title={title} backTitle={backTitle || "Back to lists"} onHandleToggleSideNav={onHandleToggleSideNav} />

					<div className="main__page">{props.initialized && React.cloneElement(children, { ...props })}</div>

					<footer className="main__copyright">© {new Date().getFullYear()} Altecflex.my. All Rights Reserved.</footer>
				</div>
			</main>
		</div>
	);
};

export default compose(memo, withProfile, withCompanies)(AppLayout);
